import { Action, Selector, State, StateContext, Store } from '@ngxs/store';
import * as actions from './puzzle-time-record.actions';
import { PuzzleTimeRecordModel } from './puzzle-time-record.model';
import { PuzzleGameModel } from './puzzle-game.model';
import { PuzzleGameState } from './puzzle-game.state';

import { Injectable } from '@angular/core';
// @dynamic
@State<Array<PuzzleTimeRecordModel>>({
  name: 'puzzleTimeRecordStates',
  defaults: [],
})
@Injectable()
export class PuzzleTimeRecordState {
  constructor(private store: Store) {}

  private static filterTimeRecords(timeRecords, puzzleID, remove = true) {
    return timeRecords.filter((timeRecord) =>
      remove ? timeRecord.puzzleID !== puzzleID : timeRecord.puzzleID === puzzleID
    );
  }

  @Selector()
  static getTimeRecordByID(state: PuzzleTimeRecordModel[]) {
    return (puzzleID: string) => {
      const puzzleTimeRecords = PuzzleTimeRecordState.filterTimeRecords(state, puzzleID, false);
      if (puzzleTimeRecords.length) {
        return puzzleTimeRecords[0];
      }
      return null;
    };
  }

  @Action(actions.InitTimeRecord)
  InitTimeRecord(state: StateContext<Array<PuzzleTimeRecordModel>>, action: actions.InitTimeRecord) {
    const timeRecords = PuzzleTimeRecordState.filterTimeRecords(state.getState(), action.payload.puzzleID);
    state.setState(timeRecords.concat(action.payload));
  }

  // @Action(actions.SetTimeRecord)
  // SetTimeRecord(state: StateContext<Array<PuzzleTimeRecordModel>>, action: actions.SetTimeRecord) {
  //   const timeRecords = PuzzleTimeRecordState.filterTimeRecords(state.getState(), action.payload.puzzleID);
  //   state.setState(timeRecords.concat(action.payload));
  // }

  @Action(actions.InitTime)
  InitTime(state: StateContext<Array<PuzzleTimeRecordModel>>, action: actions.InitTime) {
    const timeRecords = state.getState();
    state.setState(this.initTime(timeRecords, action));
  }

  @Action(actions.UpdateTime)
  async UpdateTime(state: StateContext<Array<PuzzleGameModel>>, action: actions.UpdateTime) {
    const puzzleGame = (await this.store
      .selectOnce(PuzzleGameState.getByID(action.payload.puzzleID))
      .toPromise()) as PuzzleGameModel;

    if (puzzleGame && puzzleGame.finished) {
      action.preventUpdate = true;
      return;
    }
    const puzzleTimeRecords = this.updateTime(state.getState(), action);
    state.setState(puzzleTimeRecords);
  }

  private initTime(timeRecords, action) {
    return timeRecords.map((timeRecord: PuzzleTimeRecordModel) => {
      if (timeRecord.puzzleID !== action.payload.puzzleID) {
        return timeRecord;
      }
      const newTimeRecord: PuzzleTimeRecordModel = JSON.parse(JSON.stringify(timeRecord));
      newTimeRecord.timeRecord.startedTime = new Date().getTime();
      return newTimeRecord;
    });
  }

  private updateTime(timeRecords, action: actions.UpdateTime) {
    return timeRecords.map((timeRecord: PuzzleTimeRecordModel) => {
      if (timeRecord.puzzleID !== action.payload.puzzleID) {
        return timeRecord;
      }
      const newTimeRecord: PuzzleTimeRecordModel = JSON.parse(JSON.stringify(timeRecord));
      const now = new Date().getTime();
      newTimeRecord.timeRecord.gameTime += now - newTimeRecord.timeRecord.startedTime;
      const hours = Math.floor(newTimeRecord.timeRecord.gameTime / 1000 / 3600);
      const minutes = Math.floor(newTimeRecord.timeRecord.gameTime / 1000 / 60) % 60;
      const seconds = Math.floor(newTimeRecord.timeRecord.gameTime / 1000) % 60;
      newTimeRecord.timeRecord.timeString = '';

      if (hours) {
        newTimeRecord.timeRecord.timeString += hours + ':';
        newTimeRecord.timeRecord.timeString += (minutes < 10 ? '0' : '') + minutes;
      } else {
        newTimeRecord.timeRecord.timeString += minutes;
      }

      newTimeRecord.timeRecord.timeString += ':' + (seconds < 10 ? '0' : '') + seconds;
      newTimeRecord.timeRecord.startedTime = now;
      return newTimeRecord;
    });
  }
}
